<template>
  <v-container fluid class="pr-0 pl-0 pt-0">
    <!-- <v-card class=" mb-1">
    <v-card-title class="primary lighten-3 body-1" v-if="treinoList != null && treinoList.length > 0">
      O que a galera anda fazendo?
    </v-card-title>
  </v-card> -->

    <v-row>
      <v-col v-for="(item, index) in treinoList" :key="item.id" cols="12" md="6" lg="4" xl="3">
        <v-card class="elevation-10 mb-0" color="grey darken-4" :disabled="$store.getters.dialogLoader">
          <v-card-title class="body-2">
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="treino-title font-weight-black">{{ item.aluno.name }}</span>
              </v-col>
              <v-col cols="12" class="pt-0">
                <span class="treino-title">{{ item.dataTreinoFormattedBrasil }}</span>
              </v-col>
            </v-row>
          </v-card-title>

          <v-img :src="item.aluno.profile.media.url" width="100%"
            :max-height="(item.seriesAsList.length < 3) ? 320 : item.seriesAsList.length * 115"
            class="white--text align-end" gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.9)">
            <v-card-text class="body-1 text-right pt-3">
              <v-row dense v-for="(serieTreino, index) in item.seriesAsList" :key="serieTreino.id">
                <v-col cols="12" class="text-left">
                  <treino-text-field-feed :serieTreino="serieTreino" :esporte="item.esporte" class="pt-2" />
                </v-col>
                <v-col cols="12" class="pb-2 pt-0 mb-2" v-if="index < item.seriesAsList.length - 1">
                  <v-divider dark></v-divider>
                </v-col>
              </v-row>

              <v-row v-if="item.coolCount > 0 || item.superCoolCount > 0">
                <v-col cols="12">
                  <span class="treino-title">
                    <v-btn color="primary" text outlined icon v-if="item.coolCount > 0">
                      {{ item.coolCount }}
                      <v-icon right>mdi-human-greeting</v-icon>
                    </v-btn>
                    <v-btn color="primary" text outlined icon class="ml-8" v-if="item.superCoolCount > 0">
                      {{ item.superCoolCount }}
                      <v-icon right>mdi-human-handsup</v-icon>
                    </v-btn>
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-img>

          <v-card-actions v-if="item.aluno.id != $store.getters.userLogged.id">
            <v-spacer></v-spacer>
            <v-btn v-bind:color="$store.getters.userLogged.coolList.includes(item.id) ? 'grey darken-1' : 'primary'"
              @click="vote(1, item.id, index)" :disabled="$store.getters.dialogLoader" outlined>
              wow!
              <v-icon right v-if="!$store.getters.userLogged.coolList.includes(item.id)">mdi-human-greeting</v-icon>
              <v-icon right v-if="$store.getters.userLogged.coolList.includes(item.id)">mdi-check-circle</v-icon>
            </v-btn>

            <v-btn
              v-bind:color="$store.getters.userLogged.superCoolList.includes(item.id) ? 'grey darken-1' : 'primary'"
              @click="vote(2, item.id, index)" :disabled="$store.getters.dialogLoader" outlined>
              woooow!
              <v-icon right v-if="!$store.getters.userLogged.superCoolList.includes(item.id)">mdi-human-handsup</v-icon>
              <v-icon right v-if="$store.getters.userLogged.superCoolList.includes(item.id)">mdi-check-circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>


    <v-card v-if="(!treinoList || treinoList.length < 1) && finishedLoad" class="elevation-5">
      <v-img width="100%" src="@/assets/images/coach-running.jpg" gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
        class="align-end">
        <v-card-text class="text-white title text-center">
          Ops... ninguém compartilhou treino ainda. Vai lá! Faz um treino e compartilha. :o)
        </v-card-text>
      </v-img>
    </v-card>


  </v-container>
</template>

<script>

import axios from "axios";
import HOST from "../ws";
import TreinoTextFieldFeed from '../components/TreinoTextFieldFeed.vue';
import {myMixin} from '../mixin'

export default {
  props: {
    source: String
  },

  components : {
    TreinoTextFieldFeed,
  },

  mixins : [
    myMixin
  ],

  data: () => ({

    myHost: HOST.HOST,

    finishedLoad : false,
    treinoList : [],

    limitList : 30,
  }),

  beforeMount () {

    this.finishedLoad = false;
    this.$store.commit("setLoader", true);
    const config = {
      headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
    };
    axios
      .post(this.myHost + "/treino/sharedtreinos", {}, config)
      .then(response => {
        this.treinoList = response.data;
        if(this.treinoList && this.treinoList.length > this.limitList){
          this.treinoList = this.treinoList.slice(0, this.limitList);
        }
        // console.log('treinos compartilhados: ' + this.countTreinos);
        this.$store.commit("setLoader", false);
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
      });
  },

  methods : {

    clickLike(treino){
      this.$store.commit("setLoader", true);
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      axios
        .post(this.myHost + "/treino/liketreino/" + treino.id, {}, config)
        .then(response => {
          treino.loveThis = !treino.loveThis;
          treino.hateThis = !treino.loveThis;
          console.log('click like : ' + response.status);  
          this.$store.commit("setLoader", false);
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
       });
    },

    vote(myVote, myTreinoId, myIndex){
      
      this.$store.commit("setLoader", true);
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      axios
        .post(this.myHost + '/treino/votar/' + myVote + '/' + myTreinoId + '/' + this.$store.getters.userLogged.id, {}, config)
        .then(response => {
          console.log('voto: ' + response.status);  
          this.$set(this.treinoList, myIndex, response.data);

        //depois, damos reload do usuario na sessao:
        this.axios({
          method: 'post',
          url : this.myHost + '/user/userbyemail', 
          headers: {
              'Content-Type' : 'application/json',
              Authorization: `Bearer ${this.$store.state.currentToken}`},           
              data : this.$store.getters.userLogged.email
        }).then((response2) => {
          this.$store.commit('addUserLogged', response2.data);
          this.$store.commit("setLoader", false);
        });
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
       });
    },


    clickHate(treino){
      this.$store.commit("setLoader", true);
      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      axios
        .post(this.myHost + "/treino/hatetreino/" + treino.id, {}, config)
        .then(response => {
          treino.hateThis = !treino.hateThis;
          treino.loveThis = !treino.hateThis;
          console.log('click hate : ' + response.status);  
          this.$store.commit("setLoader", false);
          this.finishedLoad = true;
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        this.$store.commit("logout");
        this.$router.push("/");
       });
    },

    getImage(){
      
    }

  }
};
</script>
<style>

.treino-title{
  color: rgb(65, 199, 65);
}

</style>